// Generated by Melange

import * as Buhta_landing__BlogSidebarPopular from "./BlogSidebarPopular.js";
import * as JsxRuntime from "react/jsx-runtime";

function BlogSidebar(Props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Buhta_landing__BlogSidebarPopular.make, {
      className: "mt-6 lg:mt-0"
    }),
    className: "lg:w-80 lg:mr-8 flex lg:block flex-col-reverse"
  });
}

const make = BlogSidebar;

export {
  make,
}
/* Buhta_landing__BlogSidebarPopular Not a pure module */
